import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { lucideChevronDown } from '@ng-icons/lucide';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmTableImports } from '@spartan-ng/helm/table';

import { RégionStore } from '../../administration/gestion-sites/store/région.store';
import { ConvertEtatGroupeToStringPipe } from '../../offre-regionale/pipes/convert-etat-groupe-to-string.pipe';
import { GetEtatGroupeVariantPipe } from '../../offre-regionale/pipes/get-etat-groupe-variant.pipe';
import { GetEtatRegionVariantPipe } from '../pipes/get-etat-region-variant.pipe';
import { GetEtatRegionPipe } from '../pipes/get-etat-region.pipe';

type UnwrapArray<T> = T extends (infer U)[] ? U : T;

@Component({
  selector: 'app-offre-de-formation',
  imports: [
    EmptyStateComponent,
    HlmTableImports,
    TrierParPipe,
    HlmButtonImports,
    HlmIconImports,
    ConvertEtatGroupeToStringPipe,
    GetEtatGroupeVariantPipe,
    ChipComponent,
    HlmLabelImports,
    HlmCheckboxImports,
    NgTemplateOutlet,
    HlmCardImports,
    RouterModule,
    GetEtatRegionPipe,
    GetEtatRegionVariantPipe,
  ],
  templateUrl: './offre-de-formation.component.html',
  providers: [provideIcons({ lucideChevronDown })],
})
export class OffreDeFormationComponent {
  readonly #régionStore = inject(RégionStore);

  readonly showAll = signal(false);
  readonly regions = computed(() =>
    this.#régionStore.entities().map((region) => ({
      ...region,
      sites: [
        ...region.sites.map((x) => {
          const etapes = x.etapes.map((etape) => ({ ...etape, expanded: false }));
          return { ...x, etapes };
        }),
      ],
    })),
  );
  readonly region = signal<UnwrapArray<ReturnType<typeof this.regions>> | undefined>(undefined);

  constructor() {
    effect(() => {
      const _ = this.showAll();
      this.region.set(undefined);
    });
  }

  selectionRegion(regionCode: string) {
    this.showAll.set(false);
    const region = this.regions().find((x) => x.nom === regionCode);
    if (!region) return;

    this.region.set(region);
  }
}
